import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import React, { Component } from "react";
import { createGlobalStyle } from "styled-components";
import axios from "axios";
import { apiCall_domain, apiCall_domainV2 } from "../../api";
import { Product } from "../../../Contexts/Contexts";
import ClipLoader from "react-spinners/ClipLoader";
import { MenuItem, Select } from "@mui/material";
import NewAddresses from "../../shoppingCart.js/NewAddresses";
import PulseLoader from "react-spinners/PulseLoader";
class Service extends Component {
  constructor() {
    super();
    this.state = {
      value: "",
      showBuySteps: false,
      userAddresses: [],
      depots: [],
      detailLoading: false,
      installTimes: [],
      data: {
        address: "",
        depot: "",
        day: "",
        hour: "",
      },
      selectedServiceType: "",
      error: "",
      showNewAddressForm: false,
      loading: false,
    };
  }

  componentDidMount() {
    const headers = {
      Authorization: localStorage.getItem("Api_key"),
      "content-type": "application/json",
    };
    axios
      .post(
        `${apiCall_domainV2}/customer/products/times`,
        { vendor_item_ids: [this.context.selectedVendor.vendor_item_id] },
        { headers },
      )
      .then((res) => {
        this.setState({ installTimes: res.data });
      });
  }

  getUsetAddresses = () => {
    this.setState({ detailLoading: true }, () => {
      const headers = {
        Authorization: localStorage.getItem("Api_key"),
        "content-type": "application/json",
      };
      axios
        .get(`${apiCall_domain}/customer/user/addresses`, { headers })
        .then((res) => {
          this.setState({ userAddresses: res.data.data, detailLoading: false });
        });
    });
  };
  changeField = (e) => {
    this.setState(
      {
        data: { ...this.state.data, [e.target.name]: e.target.value },
        error: "",
      },
      () => {
        this.isValid();
      },
    );
  };
  changeServiceType = (value) => {
    this.setState({ selectedServiceType: value, error: "" }, () => {
      this.isValid();
      if (value == 1 && !this.state.userAddresses.length) {
        this.getUsetAddresses();
      } else if (value == 0 && !this.state.depots.length) {
        this.getDepotAddresses();
      }
    });
  };
  getDepotAddresses = () => {
    this.setState({ detailLoading: true }, () => {
      const headers = {
        Authorization: localStorage.getItem("Api_key"),
        "content-type": "application/json",
      };
      axios
        .get(`${apiCall_domain}/customer/depots`, { headers })
        .then((res) => {
          this.setState({ depots: res.data.data, detailLoading: false });
        });
    });
  };
  handleAddToCart = () => {
    if (this.isValid()) {
      this.setState({ loading: true }, () => {
        const config = {
          Authorization: localStorage.getItem("Api_key"),
          "content-type": "application/json",
        };
        const { vendor_item_id } = this.context.selectedVendor;
        let data = {
          count: 2,
          item_id: vendor_item_id,
          install_need: 1,
          time_id: this.state.data.hour.id,
          day: this.state.data.day.georgian,
        };
        switch (this.state.selectedServiceType) {
          case 0:
            data["service_type"] = 0;
            data["depot_id"] = this.state.data.depot;
            break;
          case 1:
            data["service_type"] = 1;
            data["address_id"] = this.state.data.address;
            break;
          default:
            data = {
              count: 2,
              install_need: 0,
              item_id: vendor_item_id,
            };
            break;
        }
        axios
          .post(`${apiCall_domain}/customer/shopping-cart`, data, {
            headers: config,
          })
          .then((res) => {
            this.context.handleAddToCardModal(false);
            this.context.getShoppingCart();
          })
          .finally(() => {
            this.setState({ loading: false });
          });
      });
    }
  };
  showBuySteps = () => {
    this.setState({ showBuySteps: true });
  };
  isValid = () => {
    const messages = {
      day: "زمان نصب",
      hour: "زمان نصب",
    };
    if (this.state.selectedServiceType !== "") {
      Object.keys(this.state.data).map((key) => {
        if (this.state.data[key] == "") {
          if (this.state.selectedServiceType == 0 && key == "depot") {
            messages["depot"] = "آدرس نمایندگی";
            this.setState({ error: ` لطفا ${messages[key]} را انتخاب کنید` });
          }
          if (this.state.selectedServiceType == 1 && key == "address") {
            messages["address"] = "آدرس خود ";

            this.setState({ error: ` لطفا ${messages[key]} را انتخاب کنید` });
          }
          if (!(this.state.selectedServiceType == 2) && !this.state.data.day) {
            messages["time"] = "زمان نصب";
            this.setState({ error: ` لطفا ${messages[key]} را انتخاب کنید` });
          }
          return false;
        }
      });
    } else {
      this.setState({ error: `لطفا نوع نصب را انتخاب کنید` });
      return false;
    }
    return true;
  };
  handleNewAddressForm = (state) => {
    this.setState({ showNewAddressForm: state });
  };
  afterAddressCreate = () => {
    this.handleNewAddressForm(false);
    this.getUsetAddresses();
  };
  render() {
    const GlobalStyles = createGlobalStyle`body{
      background: #F9F9F9;
    }`;
    const { force_install, need_install, city_match, is_mobile } =
      this.context.selectedVendor;
    return (
      <>
        <GlobalStyles />
        <div className="newOneBody">
          {this.state.showNewAddressForm ? (
            <NewAddresses
              backHandler={() => {
                this.handleNewAddressForm(false);
              }}
              afterSuccess={this.afterAddressCreate}
            />
          ) : (
            <>
              <div className="head">
                <span className="title">افزودن به سبد خرید</span>
                <i
                  className="icon-times"
                  onClick={() => {
                    this.context.handleAddToCardModal(false);
                  }}
                />
              </div>
              <div className="content">
                <div className="serviceTypes">
                  <span className="title">نوع سرویس</span>
                  <FormControl component="fieldset" sx={{ width: "100%" }}>
                    <RadioGroup
                      value={this.state.selectedServiceType}
                      onChange={(e, value) => {
                        this.changeServiceType(+value);
                      }}
                    >
                      {}
                      <div
                        className={`${
                          (city_match === 0 &&
                            need_install &&
                            force_install === 0) ||
                          is_mobile === "MOBILE"
                            ? "disable"
                            : ""
                        } serviceType`}
                        onClick={() => {
                          this.changeServiceType(0);
                        }}
                      >
                        <Radio
                          value={0}
                          disabled={
                            city_match === 0 &&
                            need_install &&
                            force_install === 0
                          }
                        />
                        <div className="info">
                          <span className="name">
                            سرویس نصب ثابت (در محل تامین کننده)
                          </span>
                          <span className="description">
                            هزینه نصب به مبلغ فاکتور اضافه خواهد شد
                          </span>
                        </div>
                      </div>
                      <div
                        className={`${
                          (city_match === 0 &&
                            need_install &&
                            force_install === 0) ||
                          is_mobile === "FIX"
                            ? "disable"
                            : ""
                        } serviceType`}
                        onClick={() => {
                          this.changeServiceType(1);
                        }}
                      >
                        <Radio
                          value={1}
                          disabled={
                            city_match === 0 &&
                            need_install &&
                            force_install === 0
                          }
                        />
                        <div className="info">
                          <span className="name">
                            سرویس نصب سیار (در محل شما)
                          </span>
                          <span className="description">
                            هزینه نصب + هزینه ایاب و ذهاب به فاکتور اضافه خواهد
                            شد
                          </span>
                        </div>
                      </div>
                      <div
                        className={`${
                          force_install === 1 ? "disable" : ""
                        } serviceType`}
                        onClick={() => {
                          this.changeServiceType(2);
                        }}
                      >
                        <Radio value={2} disabled={!!force_install} />
                        <div className="info">
                          <span className="name">بدون نصب</span>
                        </div>
                      </div>
                    </RadioGroup>
                  </FormControl>
                </div>
                {this.state.selectedServiceType !== "" &&
                this.state.selectedServiceType !== 2 ? (
                  this.state.detailLoading ? (
                    <div className="loader">
                      <ClipLoader size={50} color="#831f82" loading={true} />
                    </div>
                  ) : (
                    <>
                      <div className="addresses">
                        {this.state.selectedServiceType === 1 ? (
                          <>
                            <div className="header">
                              <span className="title">لیست آدرس های من</span>
                              <span
                                onClick={this.handleNewAddressForm}
                                className="newAddress"
                              >
                                <i className="icon-plus" /> افزودن آدرس جدید
                              </span>
                            </div>
                            <div className="content">
                              <FormControl component="fieldset">
                                <RadioGroup
                                  value={+this.state.data.address}
                                  onChange={this.changeField}
                                  name="address"
                                >
                                  {this.state.userAddresses.map((address) => (
                                    <div className="address">
                                      <FormControlLabel
                                        value={address.id}
                                        control={<Radio />}
                                        label={address.title}
                                      />
                                    </div>
                                  ))}
                                </RadioGroup>
                              </FormControl>
                            </div>
                          </>
                        ) : (
                          <>
                            <div className="header">
                              <span className="title">لیست نمایندگان</span>
                            </div>
                            <div className="content">
                              <FormControl component="fieldset">
                                <RadioGroup
                                  value={+this.state.data.depot}
                                  onChange={this.changeField}
                                  name="depot"
                                >
                                  {this.state.depots.map((address) => (
                                    <div className="address">
                                      <FormControlLabel
                                        value={address.id}
                                        control={<Radio />}
                                        label={address.name}
                                      />
                                    </div>
                                  ))}
                                </RadioGroup>
                              </FormControl>
                            </div>
                          </>
                        )}
                      </div>

                      <div className="installTimes">
                        <span className="title">نوع سرویس</span>
                        <div className="content">
                          <div className="installTime">
                            <Select
                              sx={{
                                width: "100%",
                                borderRadius: "8px",
                                boxShadow: "none",
                              }}
                              displayEmpty
                              value={this.state.data.day}
                              name="day"
                              className="timeSelectBox"
                              onChange={this.changeField}
                            >
                              <MenuItem value="" disabled>
                                انتخاب روز
                              </MenuItem>
                              {this.state.installTimes.map((time, index) => (
                                <MenuItem value={time} key={index}>
                                  {time.jalali}
                                </MenuItem>
                              ))}
                            </Select>
                          </div>
                          {this.state.selectedServiceType !== 1 ? (
                            <div className="installTime">
                              <Select
                                displayEmpty
                                sx={{
                                  width: "100%",
                                  borderRadius: "8px",
                                  boxShadow: "none",
                                }}
                                value={this.state.data.hour}
                                name="hour"
                                className="timeSelectBox"
                                onChange={this.changeField}
                              >
                                <MenuItem value="" disabled>
                                  انتخاب ساعت
                                </MenuItem>
                                {this.state.data.day?.hours?.map(
                                  (hour, index) => (
                                    <MenuItem value={hour} key={index}>
                                      {hour.start_ts} تا {hour.stop_ts}
                                    </MenuItem>
                                  ),
                                )}
                              </Select>
                            </div>
                          ) : null}
                        </div>
                      </div>
                    </>
                  )
                ) : null}
                {this.state.error ? (
                  <button className="submit disabled" type="submit">
                    {this.state.error}
                  </button>
                ) : (
                  <button
                    className="submit"
                    type="submit"
                    onClick={this.handleAddToCart}
                  >
                    {this.state.loading ? (
                      <PulseLoader color="#fff" size={9} />
                    ) : (
                      "افزودن به سبد خرید"
                    )}
                  </button>
                )}
              </div>
            </>
          )}
        </div>
      </>
    );
  }
}
Service.contextType = Product;
export default Service;
